import React from 'react'
import "./Home.css"

const Home = () => {
  return (
    <div className='home-main'>
        <div className='home-main1'>
            <div className='home11'>
      <h1>
        <span className='span1'>Ready To Start A </span> <br /> <span className='span2'> Successful  </span> <br /> <span className='span1'> Life on Belief? </span> 
      </h1>
      </div>
      <div className="home12">
        <p>
        The redPhantom Group is a grate resource for reshaping youth and communities toward success with a perticular empasis on youth development

        </p>
      </div>
      </div> 
    </div>
  )
}

export default Home
